import Img from "next/image";
import React, { ReactElement } from "react";

import { ToTopButton } from "@/components/molecules/buttons/ToTopButton";

export default function Error404Page() {
  return (
    <div className="p-8 text-center md:p-24">
      <div className="m-auto w-[201px] h-[222px]">
        <Img src={`/customer/img/404-robot.svg`} width={201} height={222} alt="" />
      </div>
      <h1 className="mt-20 text-5xl font-medium md:text-7xl">
        <span className="">404</span>{" "}
        <span className="text-4xl md:text-5xl">Not Found</span>
      </h1>
      <p className="mt-2 text-lg md:text-2xl">ページが見つかりませんでした。</p>
      <p className="mt-8 mb-16 text-base md:text-sm">
        申し訳ございませんが、お探しのページが見つかりませんでした。
        <br />
        お手数をおかけしますが、URLをお確かめの上、再度お試しください。
      </p>
      <ToTopButton />
    </div>
  );
}

Error404Page.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};
